import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon, WalletIcon } from "@phosphor-icons/react";
import StatsCard from "components/ui/StatsCard";
import SidebarLayout from "components/Layout/Layout";
import TransactionHistory from "pages/Dasboard/MainDashBoard/component/TransactionHistory";

const TransactionMainPage = () => {
    return (
        <SidebarLayout>
            <div className="space-y-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    <StatsCard
                        title="Total Accounts"
                        icon={<CardsThreeIcon size={20} color="#fff" />}
                        value={150}
                        iconBg="#d97706"
                    />
                    <StatsCard
                        title="Active Users"
                        icon={<UsersIcon size={20} color="#fff" />}
                        value={120}
                        iconBg="#16a34a"
                    />
                    <StatsCard
                        title="Total Balance"
                        icon={<WalletIcon size={20} color="#fff" />}
                        value={50000}
                        iconBg="#2563eb"
                    />
                    <StatsCard
                        title="Total Trades"
                        icon={<ArrowsLeftRightIcon size={20} color="#fff" />}
                        value={300}
                        iconBg="#7c3aed"
                    />
                </div>

                <TransactionHistory
                    option={{
                        title: true,
                        table: true,
                        filter: true,
                        pagination: true,
                    }}
                />
            </div>
        </SidebarLayout>
    );
};

export default TransactionMainPage;
